import { INTERFACE_BASE_URL, WEIXIN_LOGIN_HOST, API_SECRET } from "./config";
import Axios from "axios";
import { instance as Loading } from "@/plugins/loading/";
import { instance as Toast } from "@/plugins/toast/";
import $localStorage from "@/utils/localStorage";
import JSMD5 from "md5";

const axiosInstance = Axios.create({
	baseURL: INTERFACE_BASE_URL
});
const xxUserInfo = $localStorage.get("xxUserInfo") || {};

axiosInstance.interceptors.request.use(
	config => {
		console.info("request config:");
		console.info(config);
		if (!config.noLogin && !(xxUserInfo.openid && xxUserInfo.user_id)) {
			return Promise.reject({
				data: {
					errcode: "401",
					errmsg: "未登录，请重新登录"
				}
			});
		}
		let dataString = API_SECRET;
		// 如果有data
		if (config.data) {
			dataString = JSON.stringify(config.data) + API_SECRET;
		}
		let sign = JSMD5(dataString);
		config.headers.sign = sign;

		if (!config.noLoading) {
			Loading.show();
		}
		return config;
	},
	error => {
		console.error("request error:");
		console.error(error);
		return Promise.reject(error);
	}
);

axiosInstance.interceptors.response.use(
	response => {
		console.info("response data:");
		console.info(response);
		let data = response.data;
		if (!response.config.noLoading) {
			Loading.hide();
		}
		if (!response.config.noToast) {
			if (data.errcode != 0 && data.errmsg) {
				Toast.show(data.errmsg);
			}
		}
		return data;
	},
	error => {
		console.error("response error:");
		console.error(error);
		// 重新登录
		if (error.data && error.data.errcode == "401") {
			let redirectUrl = encodeURIComponent(window.location.href);
			let url = encodeURIComponent(
				`${window.location.origin}/wxLogin.html?redirectUrl=${redirectUrl}`
			);
			window.location.replace(`${WEIXIN_LOGIN_HOST}/auth?url=${url}`);
			return Promise.reject(error);
		}
		if (!error.config.noLoading) {
			Loading.hide();
		}
		if (!error.config.noToast && error.response.data && error.response.data.message) {
			Toast.show(error.response.data.message);
		}
		return Promise.reject(error);
	}
);

export default axiosInstance;
